import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import {
  personalInformationProtectNodes,
  personalInfoSdkTableRows,
} from './PersonalInformationProtectContent';
import { renderH5PolicyNodes } from '../h5-policy/renderH5PolicyNodes';
import '../h5-policy/H5PolicyStyle.css';

const PersonalInformationProtectPage: React.FC = observer(() => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = '个人信息保护政策';
  }, []);

  return (
    <div className="h5-policy-page">
      <div className="h5-policy user-rule policy-wrap">
        {renderH5PolicyNodes(
          personalInformationProtectNodes,
          personalInfoSdkTableRows
        )}
      </div>
    </div>
  );
});

export default PersonalInformationProtectPage;
